import React from "react";
import PropTypes from "prop-types";
import { Box, Paper, Typography } from "@mui/material";
import { contentCardContentSx, contentEditorCardSx, contentSectionTitleSx } from "./contentEditorStyles";

const ContentSectionCard = ({ title, children, noPadding = false, sx }) => (
  <Paper
    elevation={0}
    sx={{
      ...contentEditorCardSx,
      height: "auto",
      ...(noPadding ? { overflow: "hidden" } : {}),
      ...sx,
    }}
  >
    {title ? (
      <Box sx={{ px: 1.5, pt: 1.5, pb: 0 }}>
        <Typography component="h3" sx={{ ...contentSectionTitleSx, mb: title && noPadding ? 0.75 : 1 }}>
          {title}
        </Typography>
      </Box>
    ) : null}
    <Box sx={{ ...(noPadding ? { p: 0, "&:last-child": { pb: 0 } } : contentCardContentSx) }}>{children}</Box>
  </Paper>
);

ContentSectionCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  noPadding: PropTypes.bool,
  sx: PropTypes.object,
};

export default ContentSectionCard;
